import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { ProductVisual } from './ProductVisual';
import { CHECKOUT_URL, PRICE, REGULAR_PRICE, PRODUCT_NAME } from '../data/offer';
const included = ['6 complete volumes (~300 landscape pages)', '129 Experiment Cards in one 10-field format', '29 printable worksheets', '6 printable field cards', '5 bonuses, including the Printable Card Deck', 'Lifetime access to your files'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="w-full bg-sand text-ink" data-id="element-237" data-mp="1rujck5o6lyyi">
      <div className="mx-auto max-w-2xl px-5 py-16 sm:py-20" data-id="element-238" data-mp="20t4rzrycwxv2">
        <div className="text-center" data-id="element-239" data-mp="20rtkpi5pd7z7">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-terra-deep" data-id="element-240" data-mp="3h74lak2p5p9c">
            Complete library
          </p>
          <h2 id="pricing-heading" className="chalk-underline mt-3 font-display text-[28px] text-sage sm:text-5xl" data-id="element-241" data-mp="3c78k0sldwbxh">
            Everything you need for every session this year
          </h2>
        </div>

        <div className="clip-corner mt-8 overflow-hidden rounded-3xl border border-sand-dark bg-white shadow-card" data-id="element-242" data-mp="4v8j6ih8q5db">
          <div className="bg-sage px-5 py-5 text-center" data-id="element-243" data-mp="erbkjm49pzz7">
            <h3 className="font-display text-xl text-cream sm:text-2xl" data-id="element-244" data-mp="eqtk0dakozlh">
              {PRODUCT_NAME}: The Complete Experiment Library
            </h3>
            <p className="mt-1 text-[13px] font-bold text-ochre-soft" data-id="element-245" data-mp="3i7sfdjjgsaf9">
              6 Volumes + 5 Bonuses
            </p>
          </div>

          <div className="p-5 sm:p-7" data-id="element-246" data-mp="3n6d9r2c1bzvs">
            <ProductVisual className="rounded-xl shadow-none" data-id="element-247" data-mp="3rxv8djql5odl" />

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-248" data-mp="3rzeonac8rzfd">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-sm" data-id="element-249" data-mp="2ui7ma7tljws9">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-sage/15" data-id="element-250" data-mp="2zgiy2o3gchd4">
                    <CheckIcon className="h-3 w-3 text-sage" aria-hidden="true" data-id="element-251" data-mp="2res0w4ik4swv" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-sand-dark pt-6 text-center" data-id="element-252" data-mp="3164ub0k07r50">
              <p className="text-[13px] text-ink-soft" data-id="element-253" data-mp="2w8mjf4mff1ud">
                Regular price{' '}
                <span className="text-ink-muted line-through" data-id="element-254" data-mp="28h7dz2zcs4ew">
                  ${REGULAR_PRICE} USD
                </span>
              </p>
              <div className="mt-1 flex items-start justify-center gap-1 text-sage" data-id="element-255" data-mp="23l0ffv9adv6z">
                <span className="mt-2.5 font-display text-3xl" data-id="element-256" data-mp="2ihre22b4z2vj">$</span>
                <span className="font-display text-6xl leading-[0.9] sm:text-7xl" data-id="element-257" data-mp="2dg23sovqmt8i">
                  {PRICE}
                </span>
                <span className="mt-3 text-[13px] font-bold text-ink-muted" data-id="element-258" data-mp="3ttij2bdjtge1">
                  USD
                </span>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-259" data-mp="anaye07g0op">
                <span className="rounded-full bg-ochre px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-ink" data-id="element-260" data-mp="cqbhryzhc7o">
                  Launch price
                </span>
                <span className="rounded-full border border-sand-dark px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-ink-soft" data-id="element-261" data-mp="3ngwfsgi91085">
                  One-time payment
                </span>
                <span className="rounded-full border border-sand-dark px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-ink-soft" data-id="element-262" data-mp="j1n47reqfwns">
                  Lifetime access
                </span>
              </div>

              <CtaButton href={CHECKOUT_URL} className="mt-5" data-id="element-263" data-mp="ea5578w9s65g">
                Get Gestalt Session Ready — ${PRICE}
              </CtaButton>

              <p className="mt-3 text-xs text-ink-muted" data-id="element-264" data-mp="11yocpm7hwewh">
                Backed by the 7-day money-back guarantee
              </p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-ink-soft" data-id="element-265" data-mp="16sk8ci0adpoh">
                <li className="flex items-center gap-1.5" data-id="element-266" data-mp="3f55vzbt5ko20">
                  <LockIcon className="h-4 w-4 text-terra-deep" aria-hidden="true" data-id="element-267" data-mp="3a7nq5uafmoy8" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-268" data-mp="35b5pp6m4xcrp">
                  <ZapIcon className="h-4 w-4 text-terra-deep" aria-hidden="true" data-id="element-269" data-mp="319bu3cqsqyye" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-270" data-mp="3syx3kenbpxv3">
                  <ShieldCheckIcon className="h-4 w-4 text-terra-deep" aria-hidden="true" data-id="element-271" data-mp="3szglhvcz4m94" />
                  7-day guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-ink-muted" data-id="element-272" data-mp="3k6d276fndf6k">
          Price in USD. You&apos;ll be charged the equivalent in your local
          currency.
        </p>
      </div>
    </section>;
}